import React from 'react';
import { observer } from 'mobx-react-lite';
import { freeBetStore } from '@pascal/pascal-core/shared/core/store/freeBetStore';

import { Any } from './any';
import { marketsStore } from '../../../store/marketsStore';
import { MoreContentWrapper } from './moreContentWrapper';

const TabsContent = observer(
  ({ defaultActiveTab, activeTabIndex, replayActiveMainMoreSection }) => {
    const { moreMarketsData, setSelectedMarket, selectedMarket } = marketsStore;
    const { activeFreeBet } = freeBetStore;

    const anyBetTypeData = moreMarketsData.map((el) => el[2]);

    const moreBetTypeData = moreMarketsData?.map((el) => [el[0], el[1]]);

    const redBetTypeData = moreMarketsData.map((el) => el[0]);

    const blackBetTypeData = moreMarketsData.map((el) => el[1]);

    return (
      <div className='g-events-btn-content'>
        {(defaultActiveTab === activeTabIndex && !replayActiveMainMoreSection) ||
        defaultActiveTab === replayActiveMainMoreSection ? (
          <Any
            activeFreeBet={activeFreeBet}
            activeTabIndex={activeTabIndex}
            anyBetTypeData={anyBetTypeData}
            selectedMarket={selectedMarket}
            setSelectedMarket={setSelectedMarket}
          />
        ) : (
          <MoreContentWrapper
            activeFreeBet={activeFreeBet}
            activeTabIndex={activeTabIndex}
            selectedMarket={selectedMarket}
            redBetTypeData={redBetTypeData}
            moreBetTypeData={moreBetTypeData}
            blackBetTypeData={blackBetTypeData}
            setSelectedMarket={setSelectedMarket}
          />
        )}
      </div>
    );
  }
);

export default TabsContent;
